// imports
import { Address } from 'abitype';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { alchemy } from '../../../api';
import { msgFromError } from '../../utils';
import { Chain } from '../../../web3/types';
import { TEXTS } from '../../../../constants';
import { WLHeroNFT, WLBackpackItem } from '../../../web3';

// exports
export const fetchHeroes = createAsyncThunk(
  'user/heroes/fetch',
  (_, { getState, rejectWithValue }) => {
    const { id } = (getState() as RootState).user;
    return alchemy.fetch(id as Address)
      .then((L1TokenIds) => WLHeroNFT.getOwned(L1TokenIds))
      .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_HEROES)));
  },
  {
    condition: (_, { getState }) => {
      const {
        config: { fetchStatus: configFetchStatus },
        user: { heroes: { fetchStatus: heroesFetchStatus } }
      } = getState() as RootState;
      return (configFetchStatus === 'success' && heroesFetchStatus !== 'loading');
    }
  }
);
export const updateHeroesChain = createAsyncThunk(
  'user/heroes/updateChain',
  (body: { tokenIds: number[]; targetChain: Chain }, { rejectWithValue }) => WLHeroNFT.switchChains(body.tokenIds, body.targetChain)
    .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_SWITCH_HEROES))),
  {
    condition: (_, { getState }) => {
      const { user: { heroes: { fetchStatus: heroesFetchStatus } } } = getState() as RootState;
      return (heroesFetchStatus !== 'loading');
    }
  }
);
export const fetchBackpackItems = createAsyncThunk(
  'user/backpack/fetch',
  (_, { getState, rejectWithValue }) => {
    const { config: { items } } = getState() as RootState;
    const configLookUp = Object.values(items).reduce((acc, item) => {
      acc[item.chainMetaId] = item.id;
      return acc;
    }, {} as { [key: string]: string });
    const itemIds = Object.keys(configLookUp).map((chainMetaId) => BigInt(chainMetaId));
    return WLBackpackItem.getOwned(itemIds)
      .then((data) => itemIds.reduce((acc, itemId, idx) => {
        acc[configLookUp[`${itemId}`]] = Number(data[idx]);
        return acc;
      }, {} as { [key: string]: number }))
      .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_ITEMS)));
  },
  {
    condition: (_, { getState }) => {
      const {
        config: { fetchStatus: configFetchStatus },
        user: { backpack: { fetchStatus: backpackFetchStatus } }
      } = getState() as RootState;
      return (configFetchStatus === 'success' && backpackFetchStatus !== 'loading');
    }
  }
);

export default {
  fetchHeroes, updateHeroesChain, fetchBackpackItems
};
